import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getDigiResponse } from '../../Actions/DigiLockerActions';


function EAadhaarDigiLockerCallback() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const transId = searchParams.get('ts_trans_id');
    const check = searchParams.get('check_redirect');
    // localStorage.setItem("digiResponse", 1);
    // console.log(transId);
    const reference = localStorage?.getItem('reference');
    const eAadhaarData = JSON.parse(localStorage.getItem('eAadhaarDigiData'));
    console.log("location data....", eAadhaarData)
    // if(eAadhaarData?.tsTransID == ''){
    //   transId = JSON.parse(localStorage.getItem('digiTransId'));
    // }

    useEffect(() => {
      if(check == 'eaadhar'){
        // eAadhar
        navigate(`../case-initiation/check-detail/${reference}/eaadhar`, {
          state: {
            eAadhaarDigilocker: 1,
            transId: transId,
            initial_case_id: eAadhaarData?.initial_case_id
          }
        });
      }else{
        // Aadhar Nid
        navigate(`../case-initiation/check-detail/${reference}/nid`, {
          state: {
            eAadhaarDigilocker: 1,
            transId: transId,
            initial_case_id: eAadhaarData?.initial_case_id
          }
        });

      }
      // dispatch(getDigiResponse(transId, callback));
      // navigate(`../case-initiation/check-detail/${reference}/3/digidata`);
    },[])

    // const callback = (data) => {
    //   console.log(data);
    //   navigate(`../case-initiation/check-detail/${reference}/3/digidata`);
    // };

  return (
    <div>EAadhaarDigiLockerCallback</div>
  )
}

export default EAadhaarDigiLockerCallback
